import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_shipment_contentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { shipmentIds: number[], loadTasks?: boolean }): 
  Promise<{ result: { Amount?: number, LicensePlate?: { ShipmentId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipmentIds)) {
      $missingRequiredInParams.push('\'shipmentIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { shipmentIds: number[], loadTasks?: boolean, $top?: number, $skip?: number }): 
  Promise<{ result: { Amount?: number, LicensePlate?: { ShipmentId?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipmentIds)) {
      $missingRequiredInParams.push('\'shipmentIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { shipmentIds: number[], loadTasks?: boolean, $keys: any[] }): 
  Promise<{ result: { Amount?: number, LicensePlate?: { ShipmentId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipmentIds)) {
      $missingRequiredInParams.push('\'shipmentIds\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      shipmentIds: number[], loadTasks?: boolean    }) {
        if(isNil($inParams.shipmentIds)) {
          return true; 
        }
      return false;
    }
}
